'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

/**
 * A simple slide transition.
 *
 * @public
 * @property {Array} in
 *   Fades in
 * @property {Array} out
 *   Fades out
 */
var fade = {
  in: (0, _styledComponents.css)(['opacity:calc(1 - var(--time));']),
  out: (0, _styledComponents.css)(['opacity:var(--time);'])
};

exports.default = fade;
//# sourceMappingURL=fade.js.map